<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li>
                <a href="/#/"><i class="fas fa-fw fa-home"></i> {{'general.home' | translate }}</a>
            </li>
            <li>
                <a href="/#/">{{'general.settings' | translate }}</a>
            </li>
            <li class="active">
                <strong>{{'general.settings' | translate}}</strong>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content">
    <div class="row" data-equalizer="">
        <div class="col-lg-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5>
                        <i class="fas fa-fw fa-satellite-dish"></i>{{'general.settings' | translate}}
                    </h5>
                </div>
                <div class="ibox-content" style="position: relative">
                    <ngx-loading [show]="loading"></ngx-loading>
                    <!-- Button -->
                    <button id="submit " name="submit " class="btn btn-primary " (click)="ResetIssueCache()">
                        <i class="fas fa-fw fa-bomb "></i> Reset cache issues</button>
                    <button id="submit " name="submit " class="btn btn-primary " (click)="ResetDeviceCache()">
                        <i class="fas fa-fw fa-bomb "></i> Reset cache devices</button>
                    <button id="submit " name="submit " class="btn btn-primary " (click)="ResetAssetCache()">
                        <i class="fas fa-fw fa-bomb "></i> Reset cache assets</button>
                    <button id="submit " name="submit " class="btn btn-primary " (click)="ResetDriverCache()">
                        <i class="fas fa-fw fa-bomb "></i> Reset cache drivers</button>

                    <div style="clear:both "></div>
                </div>
            </div>
        </div>
    </div>
</div>